// @flow
import {createContext} from 'react';

import type {AbacusEvaluationData} from '../../types';

export class NoExperimentChildrenContextProviderError extends Error {
    constructor() {
        super(
            `A parent <Experiment> component is required when using On, Off, or Variant components. Did you remove an <Experiment> and forget to clean up its On, Off or Variant children?`
        );
        // This garbage below is to keep tests from failing when running with
        // coverage;
        // c.f. https://github.com/istanbuljs/babel-plugin-istanbul/issues/143
        // c.f. https://github.com/babel/babel/issues/4485#issuecomment-315569892

        // $FlowFixMe
        this.constructor = NoExperimentChildrenContextProviderError;
        // $FlowFixMe
        this.__proto__ = NoExperimentChildrenContextProviderError.prototype; // eslint-disable-line no-proto
    }
}

// Sentinel value passed to On, Off, Variant components when rendered with no
// ExperimentChildrenContext provider above them, so they can throw an error.
const NO_EXPERIMENT_CHILDREN_CONTEXT_PROVIDER = {
    bucket: {bucketConfig: ''},
    experimentInstanceId: -1,
    experimentKey: {experimentId: -1, experimentName: 'default'},
    value: 0
};

type ExperimentChildrenContextValue = AbacusEvaluationData | void;

/**
 * To be used within consumers of this context to throw an error if no provider
 * was present.
 * @param {ExperimentChildrenContextValue} context
 */
export const throwIfNoExperimentChildrenContextProvider = (
    context: ExperimentChildrenContextValue
): boolean => {
    if (context === NO_EXPERIMENT_CHILDREN_CONTEXT_PROVIDER) {
        throw new NoExperimentChildrenContextProviderError();
    }
    return true;
};

/**
 * ExperimentChildrenContext
 */
const ExperimentChildrenContext = createContext<ExperimentChildrenContextValue>(
    NO_EXPERIMENT_CHILDREN_CONTEXT_PROVIDER
);
export default ExperimentChildrenContext;
